$mol_switch $mol_check_list
	value? \
